export default {"src":"/_next/static/media/out-off-stock.c843c55d.svg","height":16,"width":16};